<template>
  <div class="agency-screen">
     <b-tabs class="tabs-payment">
       
        <b-tab @click="infiniteHandlerApproveOrReject($refs.infiniteLoadingApproveOrReject)" class="tab">
          <template v-slot:title>
							<span>{{
								 $t("agency.waitingForApproval")
							}}</span>
						</template>
            <div class="search-input">
              <b-form-input
                class="input-search"
                :placeholder="$t('userDashboard.messages.search')"
                v-model="configApproveOrRejected.search"
              ></b-form-input>
              <MagnifyIcon class="icon-search" />
             
            </div>
            <div class="content-body-div" :class="{ 'no-data': !agencyApproveOrRejected.length }">
              <b-row no-gutters>
                <div v-for="(item, index) in agencyApproveOrRejected" :key="index">
                  <b-col cols="3" >
                    <div class="template-item">
                      <div class="button-div d-flex flex-row justify-content-space-between" style="position: absolute;">
                          <b-button @click="reject(item)"><IconTrash/></b-button>
                          <b-button @click="accept(item)"><IconCheck style="color:var(--projectPrimaryColor)"/></b-button>
                      </div>
                      <div @click="getAgencyData(item.id)"
                        class="agency-logo"
                        :style="{ backgroundImage: 'url(' + item.logo_url + ')' }"
                      ></div>
                      <div class="title mt-3">{{ item.name }}</div>
                    </div>
                  </b-col>
                </div>
              </b-row>
              
            </div>
            <infinite-loading
                @infinite="infiniteHandlerApproveOrReject"
                ref="infiniteLoadingApproveOrReject"
                spinner="spiral"
                throttleLimit="50"
                :distance="1"
              >
                <span slot="no-results"
                  ><b-alert show variant="light" v-if="!agencyApproveOrRejected.length">{{
                    $t("adminDashboard.list.dataEmpty")
                  }}</b-alert></span
                >
                <span slot="no-more"></span>
              </infinite-loading>
        </b-tab>
        <b-tab @click="infiniteHandler($refs.infiniteLoading)" class="tab">
						<template v-slot:title>
							<span>{{
								 $t("agency.listOfAgency")
							}}</span>
						</template>
            <div class="search-input">
              <b-form-input
                class="input-search"
                :placeholder="$t('userDashboard.messages.search')"
                v-model="config.search"
              ></b-form-input>
              <MagnifyIcon class="icon-search" />
              <b-button class="add-button ml-3" @click="resetAgency();showPopup()"
                ><IconPlus />{{$t('add company')}}</b-button
              >
            </div>
            <div class="content-body-div" :class="{ 'no-data': !agencyList.length }">
              <b-row no-gutters>
                <div v-for="(item, index) in agencyList" :key="index">
                  <b-col cols="3" >
                    <div class="template-item">
                      <div class="button-div d-flex flex-row justify-content-end" style="position: absolute;">
                          <b-button @click="deleteAgency(item)"><IconTrash/></b-button>
                          <!-- <b-button><IconSave/></b-button> -->
                      </div>
                      <div
                        class="agency-logo" @click="getAgencyData(item.id)"
                        :style="{ backgroundImage: 'url(' + item.logo_url + ')' }"
                      ></div>
                      <div class="title mt-3">{{ item.name }}</div>
                    </div>
                  </b-col>
                </div>
              </b-row>
              <infinite-loading
                @infinite="infiniteHandler"
                ref="infiniteLoading"
                spinner="spiral"
                throttleLimit="50"
                :distance="1"
              >
                <span slot="no-results"
                  ><b-alert show variant="light" v-if="!agencyList.length">{{
                    $t("adminDashboard.list.dataEmpty")
                  }}</b-alert></span
                >
                <span slot="no-more"></span>
              </infinite-loading>
            </div>
       </b-tab>
     </b-tabs>
    <b-modal
      id="popup"
      modal-class="modal-agency-template"
      size="xl"
      centered
      hide-header
      hide-footer
    >
      <div>
        <div class="modal-header">
          <h5>{{$t('agency.addAgency')}}</h5>
        </div>
        <div class="modal-body form-group">
          <div class="input-div col" id="input-group-search">
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('agency.name')}}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors ? validateErrors.name : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.name')"
                v-model="agency.name"
              ></b-form-input>
            </div>

            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('agency.ownerEmail')}}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors
                    ? validateErrors.owner_email
                    : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.ownerEmail')"
                v-model="agency.owner_email"
              ></b-form-input>
            </div>
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('agency.companyEmail')}}</label>
              <b-form-input
               
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.companyEmail')"
                v-model="agency.email"
              ></b-form-input>
            </div>
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('agency.companyPhone')}}</label>
              <b-form-input
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.companyPhone')"
                v-model="agency.phone"
              ></b-form-input>
            </div>
            <div
              class="d-flex flex-column justify-content-start m-3"
            >
              <label  :class="{
                'input-error': validateErrors ? validateErrors.avtar : false,
              }">{{$t('agency.logo')}}</label>
             
             <avtarInput
                :class="{
                  'input-error': validateErrors ? validateErrors.avtar : false,
                }"
                :avatar="agency.avtar"
                @imageSavedGetNewImage="getAvatarUser"
                @childToParent="getLogo"
                :type="'logo'"
                defaultImage="/images/company-avatar.png"
              ></avtarInput>
            </div>
            <div
              class="d-flex flex-row justify-content-center align-self-center m-3"
            >
              <b-button class="add-button ml-3" @click="checkForm()"
                >{{$t('agency.add')}}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="popup-rejected"
      modal-class="modal-agency-template"
      size="xl"
      centered
      hide-header
      hide-footer
    >
      <div>
        
        <div class="modal-body form-group">
          <div class="input-div col" id="input-group-search">
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{'Reason of rejection'}}</label>
              <b-form-textarea
                class="input-search"
                ref="searchInput"
                v-model="rejectedMessage"
              ></b-form-textarea>
            </div>
            <div
              class="d-flex flex-row justify-content-center align-self-center m-3"
            >
              <b-button class="add-button ml-3" @click="rejected()"
                >{{'Send'}}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import $ from "jquery";
import moment from "moment";
import Loading from "@/components/ui/loading";
import InfiniteLoading from "vue-infinite-loading";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import IconPlus from "@/components/icons/IconPlus";
import IconTrash from "@/components/icons/IconTrash";
import IconCheck from "@/components/icons/IconCheck";
import avtarInput from "@/components/newAvtarUploader";
export default {
  components: {
    // Loading,
    InfiniteLoading,
    MagnifyIcon,
    IconPlus,
    IconTrash,
    IconCheck,
    avtarInput,
  },
  data() {
    return {
      config: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: "",
      },
      configApproveOrRejected: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: null,
        for_approve:true
      },
      agencyList: [],
      agencyApproveOrRejected: [],
      agency: {
        name: null,
        owner_email: null,
        description: "something",
        avtar: null,
        email:null,
        phone:null,
      },
      search:null,
      validateErrors: {},
      countError: 0,
      rejectedMessage:null,
      selectedAgency:null
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.getAvatarUser();
  },
  watch: {
      'config.search'(val){
        this.searchAgency();
      },
      'configApproveOrRejected.search'(val){
        if(val){
          this.searchForApproveRejecte();
        }
      },
      
  },
  methods: {
    ...mapActions("AdminAgencyController", ["GET_AGENCIES","GET_ONE_AGENCY", "ADD_AGENCY", "UPDATE_AGENCY", "DELETE_ONE_AGENCY", "APPROVE_OR_REJECT_AGENCY"]),
    async searchAgency(){
     let obj={
        take: this.config.take,
        page: this.config.page,
        for_approve:false
      }
      if(this.config.search){
        obj.search=this.config.search;
      }
        let response = await this.GET_AGENCIES(obj);
      if (response) {
        
        this.config.itemCount = response.data.meta.itemCount;
        this.config.take = response.data.meta.take;
        this.config.page = response.data.meta.page;
        this.config.pageCount = response.data.meta.pageCount;
        this.agencyList = response.data.data;
      }
    },
    async infiniteHandler($state) {
      let obj={
        take: this.config.take,
        page: this.config.page,
        for_approve:false
      }
      if(this.config.search){
        obj.search=this.config.search;
      }
      let response = await this.GET_AGENCIES(obj);
      if (response) {
        if (!response.data.data) {
          return $state._uid?$state.stateChanger.complete():$state.complete();
        }
        this.config.itemCount = response.data.meta.itemCount;
        this.config.take = response.data.meta.take;
        this.config.page = response.data.meta.page;
        this.config.pageCount = response.data.meta.pageCount;
        if (this.config.page == 1) {
          this.agencyList = response.data.data;
        } else {
          response.data.data.forEach((elm) => {
            this.agencyList.push(elm);
          });
        }
        if (this.config.page < this.config.pageCount) {
          this.config.page += 1;
          $state._uid?$state.stateChanger.loaded():$state.loaded();
        } else{
           $state._uid?$state.stateChanger.complete():$state.complete();
        };
      }
    },
    
    getAgencyData(agencyId){
      this.GET_ONE_AGENCY({id:agencyId}).then(({data})=>{
        this.showPopup();
        this.agency.name=data.data.name;
        this.agency.owner_email=data.data.owner.email;
        this.agency.description=data.data.description;
        this.agency.email=data.data.email;
        this.agency.phone=data.data.phone_number;
        this.agency.avtar=data.data.logo_url;
        this.agency.id=data.data.id;
        this.$forceUpdate();
        
        console.log("this.agency",this.agency)
      })
    },
    resetAgency(){
      this.agency= {
        name: null,
        owner_email: null,
        description: "something",
        avtar: null,
        email:null,
        phone:null,
      }
    },
    showPopup() {
      // console.log("show popup")
      this.$bvModal.show("popup");
    },
    getAvatarUser() {
      setTimeout(() => {
        if (this.agency.avtar) {
          this.agency.avtar = this.agency.avtar;
          this.$forceUpdate();
        } else {
          this.agency.avtar = null
          this.$forceUpdate();
        }
      }, 500);
    },
    getLogo(ev) {
      this.agency.avtar = ev.file;
      this.$forceUpdate();
    },
    checkForm(e) {
      this.countError = 0;
      this.validateErrors = {};
      this.isValidate = true;
      if (this.agency.name && this.agency.name.match(/[\u1000-\uFFFF]+/g)) {
        this.validateErrors[`name`] = true;
        this.countError++;
        this.makeToastError(this.$('Marks or special characters are not allowed'));
        return;
      }
      if (!this.agency.name) {
        this.validateErrors[`name`] = true;
        this.countError++;
      }

      if (!this.agency.owner_email) {
        this.validateErrors[`owner_email`] = true;
        this.countError++;
      }
      if (!this.agency.description) {
        this.validateErrors[`description`] = true;
        this.countError++;
      }
      if (!this.agency.avtar) {
        this.validateErrors[`avtar`] = true;
        this.countError++;
      }
      console.log("this.validateErrors", this.validateErrors);
      this.addAgency();
    },
    addAgency() {
      this.$root.loading=true;
      if (!this.countError) {
        let agencyFormData = new FormData();
        agencyFormData.append("name", this.agency.name);
        agencyFormData.append("description", this.agency.description|'something');
        agencyFormData.append("owner_email", this.agency.owner_email);
        if(typeof this.agency.avtar=='object'){
          agencyFormData.append("file", this.agency.avtar);
        }
        if(this.agency.phone){
          agencyFormData.append("phone", this.agency.phone);
        }
        if(this.agency.email){
          agencyFormData.append("email", this.agency.email);
        }
        if(!this.agency.id){
          this.ADD_AGENCY(agencyFormData).then((data) => {
            this.$bvModal.hide("popup");
            this.searchAgency();
            this.$root.loading=false;
            console.log("data", data);
          }).catch((err)=>{
            this.$root.loading=false;
              this.showToast(this.$t('agency.createdError'),"danger");
          });
        }else{
            this.UPDATE_AGENCY({id:this.agency.id,body:agencyFormData}).then((data) => {
            this.$bvModal.hide("popup");
            this.searchAgency();
            this.$root.loading=false;
            console.log("data", data);
          }).catch((err)=>{
            this.$root.loading=false;
              this.showToast(this.$t('agency.createdError'),"danger");
          });
        }
      } else {
        this.$root.loading=false;
        this.showToast("Check the form!","danger");
      }
    },
    showToast(text,type){
        this.$bvToast.toast(text, {
          title: text,
          variant: type,
          solid: true,
        });
    },
    deleteAgency(item){
      this.$swal({
				title: this.$i18n.t('userDashboard.userManage.modalDelete.title'),
				text: item.name,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				cancelButtonColor: 'var(--projectPrimaryColor) !important',
				confirmButtonColor: '#DC3849',
				cancelButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				),
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				preConfirm: () => {
					 this.DELETE_ONE_AGENCY(item).then((data)=>{
                this.showToast("Agency deleted!","success");
                this.searchAgency();
            }).catch((err)=>{
                this.showToast(this.$t('agency.createdError'),"danger");
            });
				}
			});
       
    },
    async searchForApproveRejecte(){
      let obj={
        take: this.configApproveOrRejected.take,
        page: this.configApproveOrRejected.page,
        for_approve:true
      }
       if(this.configApproveOrRejected.search){
        obj.search=this.configApproveOrRejected.search;
      }
      let response = await this.GET_AGENCIES(obj);
      this.configApproveOrRejected.itemCount = response.data.meta.itemCount;
      this.configApproveOrRejected.take = response.data.meta.take;
      this.configApproveOrRejected.page = response.data.meta.page;
      this.configApproveOrRejected.pageCount = response.data.meta.pageCount;
      this.agencyApproveOrRejected = response.data.data;
    },
    async infiniteHandlerApproveOrReject($state) {
      let obj={
        take: this.configApproveOrRejected.take,
        page: this.configApproveOrRejected.page,
        for_approve:true
      }
      console.log("this.configApproveOrRejected.search)",this.configApproveOrRejected.search)
      if(this.configApproveOrRejected.search){
        obj.search=this.configApproveOrRejected.search;
      }
      let response = await this.GET_AGENCIES(obj);
      if (response) {
        if (!response.data.data) {
          return $state._uid?$state.stateChanger.complete():$state.complete();
        }
        this.configApproveOrRejected.itemCount = response.data.meta.itemCount;
        this.configApproveOrRejected.take = response.data.meta.take;
        this.configApproveOrRejected.page = response.data.meta.page;
        this.configApproveOrRejected.pageCount = response.data.meta.pageCount;
        if (this.configApproveOrRejected.page == 1) {
          this.agencyApproveOrRejected = response.data.data;
        } else {
          response.data.data.forEach((elm) => {
            this.agencyApproveOrRejected.push(elm);
          });
        }
        if (this.configApproveOrRejected.page < this.configApproveOrRejected.pageCount) {
          this.configApproveOrRejected.page += 1;
          $state._uid?$state.stateChanger.loaded():$state.loaded();
        } else $state._uid?$state.stateChanger.complete():$state.complete();
      }
    },
    rejected(){
      this.APPROVE_OR_REJECT_AGENCY({agencyId:this.selectedAgency.id,approved:false,reviewer_message:this.rejectedMessage}).then((data)=>{
        this.selectedAgency=null;
        this.rejectedMessage=null;
        this.$bvModal.hide("popup-rejected");
        this.searchForApproveRejecte();
      })
    },
    reject(item){
      this.selectedAgency=item;
      this.$bvModal.show("popup-rejected");
    },
    accept(item){
      this.$swal({
				title: 'Do you want to approve this agency?',
				text: item.name,
				customClass: {
					container: 'swal-accept-item'
				},
				showCancelButton: true,
				cancelButtonColor: '#DC3849',
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				cancelButtonText:  this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				confirmButtonText:this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				)
      }).then((result)=>{
        console.log("result",result)
        if(!result.value){
          this.APPROVE_OR_REJECT_AGENCY({agencyId:item.id,approved:true,reviewer_message:null}).then((data)=>{
            this.searchForApproveRejecte();
          })
        }
      })
    }
  },
};
</script>
<style lang="scss">
@import "adminManageAgency.scss";
</style>
